// extracted by mini-css-extract-plugin
export default {"dropdown-item-style":"Remarks_dropdown-item-style__hMuzt","placeholder-style":"Remarks_placeholder-style__ovwFY"};